import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { updateCustomersPagination } from '../../store/actions/customer/customer_action';
import { Typography, Button, Container, Grid, makeStyles } from '@material-ui/core';
import CustomersTable from './customers_table';
import SearchComponent from '../ui_components/search';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    centerAlign: {
        textAlign: 'center'
    }
}));

const CustomerList = ({ customers }) => {
    const { container, centerAlign } = useStyles();
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const { filters } = customers;

    useEffect(() => {
        if (filters?.search) {
            setSearch(filters.search);
        }
    }, []);

    const handleSearch = (e) => {
        const search = e.target.value;
        setSearch(search);
        dispatch(updateCustomersPagination({...customers, page: 0, filters: { ...filters, search }}))
    }

    const handleAddCustomerClick = () => {
        history.push(REACT_ROUTES.CUSTOMER);
    }

    return (
        <Container className={container}>
            <Typography variant="h4" align="center" gutterBottom>
                Klijenti
            </Typography>
            <Grid container justify="center" spacing={1}>
                <SearchComponent value={search} handleSearch={handleSearch} />
                <Grid item xs={8} className={centerAlign}>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleAddCustomerClick}
                    >
                        Kreirajte novog klijenta
                    </Button>
                </Grid>
            </Grid>
            <CustomersTable />
        </Container>
    )
}

CustomerList.propTypes = {
    customers: PropTypes.object
}

const mapStateToProps = (state) => ({
    customers: state.customers
});

export default connect(mapStateToProps)(CustomerList);

